<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="logo-placeholder">
          <h1>🏢</h1>
        </div>
        <h1>Tabosa Sistemas</h1>
        <p>Acesso ao Sistema</p>
      </div>
      
      <form class="login-form" @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="login">Usuário</label>
          <input 
            type="text" 
            id="login" 
            v-model="form.login"
            required 
            autocomplete="username"
            placeholder="Digite seu usuário"
          >
        </div>
        
        <div class="form-group">
          <label for="password">Senha</label>
          <input 
            type="password" 
            id="password" 
            v-model="form.password"
            required 
            autocomplete="current-password"
            placeholder="Digite sua senha"
          >
        </div>
        
        <button type="submit" class="btn-login" :disabled="loading">
          <span v-if="!loading">Entrar no Sistema</span>
          <span v-else>Entrando...</span>
        </button>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
      </form>
      
      <div class="login-footer">
        <p>&copy; 2026 Tabosa Sistemas - Todos os direitos reservados</p>
        <p class="version-info">{{ version }} | Build: {{ buildDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'md5'
import { getVersionInfo } from '../config/version'

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        login: '',
        password: ''
      },
      loading: false,
      error: '',
      ...getVersionInfo()
    }
  },
  methods: {
    async handleLogin() {
      try {
        this.loading = true
        this.error = ''
        
        // Transformar senha em MD5 antes de enviar
        const passwordMd5 = md5(this.form.password)
        console.log('Senha digitada:', this.form.password)
        console.log('MD5 gerado no Vue:', passwordMd5)
        
        const formData = {
          login: this.form.login,
          password: passwordMd5
        }
        
        try {
          console.log('Iniciando login...')
          console.log('Dados do formulário:', formData)
          
          const response = await fetch('/auth/check_auth.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(formData)
          })
          
          console.log('Resposta recebida:', response.status, response.statusText)
          console.log('Headers:', response.headers)
          console.log('Response URL:', response.url)
          console.log('Response redirected:', response.redirected)
          
          // Verificar se a resposta é JSON
          const contentType = response.headers.get('content-type')
          console.log('Content-Type:', contentType)
          
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json()
            console.log('Dados JSON:', data)
            
            if (data.success) {
              if (data.user) {
                localStorage.setItem('user', data.user.login)
                localStorage.setItem('user_name', data.user.name)
                localStorage.setItem('is_admin', data.user.is_admin)
              }
              // Redirecionar para a rota do Vue
              console.log('Login sucesso, redirecionando para:', data.redirect)
              console.log('Router disponível:', this.$router)
              console.log('Tentando redirecionar para:', data.redirect || '/dashboard')
              
              // Pequeno delay para garantir que o router esteja pronto
              setTimeout(() => {
                this.$router.push(data.redirect || '/menu').catch(err => {
                  console.error('Erro no redirecionamento:', err)
                  this.error = 'Erro ao redirecionar. Tente novamente.'
                })
              }, 100)
            } else {
              // Mostrar erro retornado pelo servidor
              console.log('Login falhou:', data.error)
              this.error = data.error || 'Usuário ou senha incorretos'
            }
          } else {
            // Se não for JSON, mostrar erro genérico
            console.log('Resposta não é JSON')
            this.error = 'Erro no servidor. Tente novamente.'
          }
        } catch (error) {
          console.error('Erro na requisição:', error)
          this.error = 'Erro de conexão. Tente novamente.'
        }
      } catch (error) {
        console.error('Erro no handleLogin:', error)
        this.error = 'Erro inesperado. Tente novamente.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(37,99,235,.11), 0 1px 4px rgba(37,99,235,.06);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo-placeholder h1 {
  font-size: 3rem;
  margin-bottom: 10px;
}

.login-header h1 {
  color: #1e293b;
  font-size: 1.5rem;
  margin-bottom: 5px;
}

.login-header p {
  color: #64748b;
  font-size: 0.9rem;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: #2563eb;
}

.btn-login {
  width: 100%;
  padding: 12px 20px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-login:hover:not(:disabled) {
  background: #1d4ed8;
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  margin-top: 15px;
  padding: 10px;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #dc2626;
  text-align: center;
  font-size: 0.9rem;
}

.login-footer {
  margin-top: 30px;
  text-align: center;
  color: #64748b;
  font-size: 0.8rem;
}

.version-info {
  margin-top: 5px;
  font-size: 0.7rem;
  color: #94a3b8;
}
</style>
